<template>
  <v-container>
    <v-card>
      <v-card-title>Board Of Directors</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-for="member in boardMembers"
            :key="member.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card>
              <v-card-title class="text-h6">{{ member.name }}</v-card-title>
              <v-card-subtitle>{{ member.position }}</v-card-subtitle>
              <v-img
                :src="member.image"
                height="200px"
                class="white--text align-end"
                gradient="to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3)"
              >
                <v-card-text>{{ member.bio }}</v-card-text>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "BoardOfDirectors",
  data() {
    return {
      boardMembers: [
        {
          id: 1,
          name: "Dave Goodwin",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Dave Goodwin bio",
        },
        {
          id: 2,
          name: "Heath Weavill",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Heath Weavill Bio",
        },
        {
          id: 3,
          name: "Melissa Clemetson",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Melissa Clemetson Bio",
        },
        {
          id: 4,
          name: "Skyler Burke",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Skyler Burke bio",
        },
        {
          id: 5,
          name: "Tim C Goodwin",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Tim C Goodwin bio",
        },
        {
          id: 5,
          name: "Chace Larsen",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Chace Larsen bio",
        },
        {
          id: 6,
          name: "Tyler Haddix",
          position: "Postion",
          image: "https://via.placeholder.com/150", // Replace with actual image URL
          bio: "Tyler Haddix bio",
        },
      ],
    };
  },
};
</script>

<style scoped>
.v-list-item {
  cursor: pointer;
}
</style>
